<template>
  <v-container fluid class="gl-journal-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/gl-journal/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindGLJournal=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>

              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_journals.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/gl-report/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Report
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_selected"
              loading-text="Loading... Please wait"
              class="journals-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_journals"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteJournal"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Journal?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_journal.journalnum }} 
                      {{ delete_journal.journalname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteJournal = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_journal)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.journalimage="{ item }">
                    <v-img
                    v-if="item.journalimage" 
                    v-bind:src="item.journalimage"
                    max-height="60"
                    max-width="60"
                  ></v-img>
              </template>
              <template v-slot:item.isTaxable="{ item }">
                <v-icon v-if="item.isTaxable==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.ledgerid="{ item }">
                <p class="two-line">{{ getLedger(item.ledgerid) }}</p>
                <p class="two-line">{{ item.journalname }}</p>
              </template>
              <template v-slot:item.journalnum="{ item }">
                
                <p class="two-line">{{ item.journaltype  }}</p>
                <p class="two-line">{{ item.journalnum  }}</p>
                <p v-if="item.journaldate!=undefined" class="two-line">{{ new Date(item.journaldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                <p v-if="item.journalduedate!==undefined" class="two-line"><b>Due: {{ new Date(item.journalduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
              </template>
              <template v-slot:item.creditAmount="{ item }">
                <p class="two-line">{{ sum_credit(item)  }}</p>
              </template>
              <template v-slot:item.debitAmount="{ item }">
                <p class="two-line">{{ sum_debit(item)  }}</p>
              </template>
              <template v-slot:item.journalstatus="{ item }">
                <p class="two-line">
                  <v-chip
                  v-if="item.journalstatus!=undefined"
                  :color="getStatusColor(item.journalstatus)"
                  small
                >
                  {{ item.journalstatus }}
                </v-chip>
                </p>
                <p class="two-line" v-html="balance_text(item)"></p>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.journalstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindGLJournal"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find GLJournals</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="GLJournal Num"
                    v-model="find_query.journalnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="GLJournal Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="9" md="9"></v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindGLJournal = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetGLJournals"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findGLJournals"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor, formatCurrency } from '@/util/tools';

export default {
  name: 'GLJournalList',
  data() {
    return {
      config,
      isDeleteJournal: false,
      isFindGLJournal: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_journal: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Journal', value: 'journalnum', sortable: false, width: '20%'},
        { text: 'Ledger & Name', value: 'ledgerid'},
        { text: 'Credit', value: 'creditAmount', width: '10%' },
        { text: 'Debit', value: 'debitAmount', width: '10%' },
        { text: 'Status', value: 'journalstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_journals: [],
      data_selected: [],
      getStatusColor: getStatusColor,
      formatCurrency: formatCurrency,
    }
  },
  computed: {
    ...mapState('GLJournal', ['gljournals', 'isReceiving', 'isDeleting', 'idToDelete', 'gljournalsMessage', 'isUpdating']),
    ...mapState('GLLedger', ['glledgers']),
    
  },
  methods: {
    ...mapActions('GLJournal', ["getGLJournalsRequest", "findGLJournalsRequest", "deleteGLJournalRequest","updateGLJournalRequest","createGLJournalRequest"]),
    ...mapActions('GLLedger', ["getGLLedgersRequest"]),
    getLedger(id){
      let find = this.glledgers.find(ledger=>ledger._id==id);
      if(find!=null) return find['ledgername'];
      return;
    },
    sum_credit(item){
      let result = item.transactions.reduce((a, b) => a + parseFloat(b.creditAmount), 0);
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    sum_debit(item){
      let result = item.transactions.reduce((a, b) => a + parseFloat(b.debitAmount), 0);
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    balance_text(item){
      let result;
      if(this.sum_debit(item) !== this.sum_credit(item)) result = '<span style="text-align: left; color: red; margin-top: 10px; font-weight: bold; font-size: 9pt;">Not In Balance</span>';
      else result = '';
      return result;
    },
    getJson(){
      let json = this.data_journals.map(journal=>{return {
        journalnum: journal.journalnum, 
        journaldate: journal.journaldate!=undefined ? new Date(journal.journaldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        journaltype: journal.journaltype,
      }});
      return json;
    },
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.journalstatus=='Completed')!=null) return false;
      return true;
    },
    getFileName(){
      var d = new Date();
      var name = 'journals-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'GLJournalEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'GLJournalPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'GLJournalView', params: item });
    },
    async findGLJournals(){
      this.isFindGLJournal = false;
      console.log('1',this.find_query)
      if(Object.keys(this.find_query).length==0){
        await this.getGLJournalsRequest();
        this.data_journals = Object.assign([], this.gljournals);
      }
      else{
        console.log('here')
        let result = await this.findGLJournalsRequest(this.find_query);
        this.data_journals = Object.assign([], result);
      }
    },
    async resetGLJournals(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deleteGLJournalRequest(item);
      this.data_journals = Object.assign([], this.gljournals);
      this.isDeleteJournal = false;
    },
    deleteDialog(item) {
      this.isDeleteJournal = true;
      this.delete_journal = {
        _id: item._id,
        journalnum: item.journalnum,
        journaltype: item.journaltype,
      }
    },
  },
  async created () {
    if(this.gljournals.length==0) await this.getGLJournalsRequest();
    if(this.glledgers.length==0) await this.getGLLedgersRequest();
    this.data_journals = Object.assign([], this.gljournals);
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
